/**
 * @generated SignedSource<<dbfd8e2613614e293a26036e2f1e1e02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WatchersList_ticket$data = {
  readonly id: string;
  readonly isWatching: boolean;
  readonly watcherCount: number;
  readonly assigneeId: string | null;
  readonly watchers: ReadonlyArray<{
    readonly id: string;
    readonly person: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ticketingPerson_person">;
    } | null;
  }>;
  readonly " $fragmentType": "WatchersList_ticket";
};
export type WatchersList_ticket$key = {
  readonly " $data"?: WatchersList_ticket$data;
  readonly " $fragmentSpreads": FragmentRefs<"WatchersList_ticket">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WatchersList_ticket",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWatching",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "watcherCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assigneeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TicketWatcher",
      "kind": "LinkedField",
      "name": "watchers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ticketingPerson_person"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Ticket",
  "abstractKey": null
};
})();

(node as any).hash = "6383af580b253e9824ae6ffb0f8daeac";

export default node;
